<script>
import cityList from './CityList.vue'

export default {
  name: 'SearchHotelHistory',
  computed: {
    cityList () {
      return cityList
    }
  },
  data () {
    return {
      resList: []
    }
  },
  methods: {
    init () {
      let res = localStorage.getItem('searchResHistory')
      this.resList = res ? JSON.parse(res) : []
    },
    toPage (item) {
      if (item.type === 'city') {
        this.toHotelList(item, 'city')
      } else if (item.type === 'searchPoiHistory') {
        this.toHotelList(item, 'poi')
      } else if (item.type === 'searchHotelHistory') {
        this.toHotelDetail(item)
      }
    },
    toHotelDetail (item) {
      this.$emit('toHotelDetail', item)
    },
    toHotelList (item, type) {
      this.$emit('toHotelList', item, type)
    },
    clearHistory () {
      localStorage.removeItem('searchResHistory')
      this.init()
    }
  }
}
</script>

<template>
<!--  <div style="min-height: 51px">-->
    <div class="history_box" v-if="resList.length" style="background-color: #dadada;">
      <div class="hotel_key_word" @mousedown.capture.prevent.stop>
        <div style="color: #737982;word-break: keep-all">历史搜索</div>
        <div class="hotel_key_word_item" v-if="resList.length">
          <div class="right">
            <div v-for="(item, index) in resList" :key="index" @click="toPage(item)">
              <div class="hotel_item" v-if="item.type === 'city'">
                <span class="name_item">
                  {{ item.sourceNameCn }} {{ item.sourceNameCn !== item.sourceName ? item.sourceName : '' }}
                </span>
              </div>
              <div class="hotel_item" v-if="item.type === 'searchPoiHistory'">
              <span class="name_item">
                {{ item.sourceNameCn }} {{ item.sourceNameCn !== item.sourceName ? item.sourceName : '' }}
              </span>
              </div>
              <div class="hotel_item" v-if="item.type === 'searchHotelHistory'">
              <span class="name_item">
                {{
                  item.sourceHotelNameCn
                }} {{ item.sourceHotelNameCn !== item.sourceHotelName ? item.sourceHotelName : '' }}
              </span>
              </div>
            </div>
          </div>
        </div>
        <div @click="clearHistory()" style="cursor: pointer;color: #737982;word-break: keep-all">清除记录</div>
      </div>
    </div>
<!--  </div>-->
</template>

<style scoped lang="less">
.hotel_key_word {
  overflow: auto;
  z-index: 50;
  display: flex;
  align-items: center;
  column-gap: 8px;
  background-color: #dadada;
  padding-bottom: 10px;

  .hotel_key_word_item {
    display: flex;
    column-gap: 15px;
  }

  .left {
    width: 100px;
    text-align: center;
    padding: 15px 0;
    border-right: 1px solid #1e50f0;
  }

  .right {
    width: 100%;
    overflow-y: scroll;
    display: flex;
    align-self: center;
    column-gap: 8px;
    flex-wrap: nowrap;

    .hotel_item {
      display: flex;
      justify-content: space-between;
      column-gap: 35px;
      cursor: pointer;
      background-color: #f3f4f6;
      padding: 7px;
      border-radius: 25px;

      .name_item {
        max-width: 160px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &:hover {
        background-color: #e5e7eb;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/SearchHotelHistory.vue